import {Service, Module} from 'app/decorators';
import _ from 'lodash';

@Module({
    name: 'app.services.token',
})
@Service('TokenService')
export default class AuthService {
    constructor ($localStorage, $cookies) {
        "ngInject";
        this.$cookies = $cookies;
        this.$storage = $localStorage.$default({
            tokens: {},
        });
        if (!$cookies.get('key')) {
            $cookies.put('key',  Math.random().toString(36).slice(2));
        }
    }

    set (token) {
        if (this.get() && this.get() !== token) {
            this.clearApiCaches();
        }
        this.$storage.tokens[this.$cookies.get('key')] = token;
        this.$storage.$apply();
    }

    get () {
        return this.$storage.tokens[this.$cookies.get('key')];
    }

    clear () {
        let self = this;
        this.clearApiCaches();
        _.each(self.$cookies.getAll(), function (v, k) {
            self.$cookies.remove(k);
        });
        this.$storage.tokens = {};
    }

    clearApiCaches () {
        if (window.ReactBridge && window.ReactBridge.clearOfflineData) {
            window.ReactBridge.clearOfflineData();
        }
        if (!('serviceWorker' in navigator)) {
            return;
        }
        navigator.serviceWorker.getRegistration().then(function (registration) {
            let worker = registration && (registration.active || registration.waiting);
            if (worker) {
                worker.postMessage({type: 'CLEAR_API_CACHES'});
            }
        }).catch(_.noop);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/token.js